import { render, staticRenderFns } from "./c_home_service.vue?vue&type=template&id=75b247ef&scoped=true&"
import script from "./c_home_service.vue?vue&type=script&lang=js&"
export * from "./c_home_service.vue?vue&type=script&lang=js&"
import style0 from "./c_home_service.vue?vue&type=style&index=0&id=75b247ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b247ef",
  null
  
)

export default component.exports